import { useQuery } from '@tanstack/react-query';
import { discountsQueryKeys, getDiscount } from '../api/discounts';
import type { DiscountResponse } from '../api/discounts';

const STALE_TIME = 30_000;

interface UseDiscountOptions {
  initialData?: DiscountResponse;
  enabled?: boolean;
}

export function useDiscount(id: number, { initialData, enabled = true }: UseDiscountOptions = {}) {
  return useQuery({
    queryKey: discountsQueryKeys.detail(id),
    queryFn: () => getDiscount(id),
    staleTime: STALE_TIME,
    enabled,
    ...(initialData ? { initialData, initialDataUpdatedAt: Date.now() } : {}),
  });
}
